import {
  EntityList,
  EntityListProps,
  renderDateTime,
  renderPersona,
} from 'components/EntityList'
import { Person, ProvingChange } from 'gql.generated'
import { uniq } from 'lodash'
import {
  ConstrainMode,
  PersonaSize,
  SelectionMode,
} from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { createFieldColumn } from 'views/helpers'

export type EditingHistoryProps = EntityListProps<ProvingChange>

export const EditingHistoryList: React.FC<EditingHistoryProps> = ({
  items,
  ...props
}) => {
  const { t } = useTranslation()
  const fieldColumn = React.useMemo(() => createFieldColumn(t), [t])

  const columns = [
    fieldColumn('change.key', {
      onRender: (item: ProvingChange, i, col) => {
        if (item.change && item.change.key && item.change.key === 'status') {
          return `Status auf: "${item.change.value}. ${t(
            `field.status.${item.change.value}`
          )}" geändert`
        } else if (
          item.change &&
          item.change.key &&
          item.change.key === '_id'
        ) {
          return 'Erprobungsanlage'
        } else {
          return 'Erprobungsänderung'
        }
      },
      getGroupValue: (item: ProvingChange) => {
        if (item.change && item.change.key && item.change.key === 'status') {
          return 'Statusänderung'
        } else if (
          item.change &&
          item.change.key &&
          item.change.key === '_id'
        ) {
          return 'Erprobungsanlage'
        } else {
          return 'Erprobungsänderung'
        }
      },
      minWidth: 100,
    }),
    fieldColumn('createdBy', {
      onRender: (item: Person, i, col) =>
        renderPersona({ size: PersonaSize.size10 })(item, i, col),
      ungroupable: true,
      minWidth: 150,
    }),
    fieldColumn('created', { onRender: renderDateTime, ungroupable: true }),
    fieldColumn('resolvedBy', {
      onRender: (item: Person, i, col) =>
        renderPersona({ size: PersonaSize.size10 })(item, i, col),
      ungroupable: true,
      minWidth: 150,
    }),
    fieldColumn('resolved', { onRender: renderDateTime, ungroupable: true }),
  ]

  return (
    <EntityList
      selectionMode={SelectionMode.none}
      alternate={true}
      stickyHeader={true}
      items={uniq(items)}
      columns={columns}
      constrainMode={ConstrainMode.horizontalConstrained}
    />
  )
}
